import { Client, Form, FormTemplate, PatientForm, SearchModel } from '@nrwl/rx-models';

import { Action } from '@ngrx/store';
import { ClientLibrarySearchPropertiesModel } from '../../models/client-library/client-library-filter-values.interface';
import { ClientLibrarySearchFilters } from '../../models/client-library/client-library-search-filters';
import { ClientLibraryRemoteFilterField } from '../../models/client-library/client-library-remote-filters-values';
import { SortClientLibrary } from '../../models/client-library/sort-client-library';

export enum ClientLibraryActionTypes {
  LoadClientLibrary = '[ClientLibrary] Load Client Library',
  LoadClientLibrarySuccess = '[ClientLibrary] Load Client Library Success',

  LoadNextClientLibraryPage = '[ClientLibrary] Load Next Client Library Page',
  LoadNextClientLibraryPageSuccess = '[ClientLibrary] Load Next Client Library Page Success',

  LoadClientLibraryFilterValues = '[ClientLibrary] Load Client Library Filter Values',
  LoadClientLibraryFilterValuesSuccess = '[ClientLibrary] Load Client Library Filter Values Success',
  LoadClientLibraryFilterValuesFailure = '[ClientLibrary] Load Client Library Filter Values Failure',

  LoadAccountLibrary = '[ClientLibrary] Load Account Library',
  LoadAccountLibrarySuccess = '[ClientLibrary] Load Account Library Success',

  LoadArchivedLibrary = '[ClientLibrary] Load Archived Library',
  LoadArchivedLibrarySuccess = '[ClientLibrary] Load Archived Library Success',

  LoadPatient = '[ClientLibrary] Load Patient',
  LoadPatientSuccess = '[ClientLibrary] Load Patient Success',

  LoadFormWithTemplate = '[ClientLibrary] Load Form Template',
  LoadFormWithTemplateSuccess = '[ClientLibrary] Load Form Template Success',

  LoadLegacyForms = '[ClientLibrary] Load Legacy Forms',
  LoadLegacyFormsSuccess = '[ClientLibrary] Load Legacy Forms Success',

  CreateForm = '[ClientLibrary] Create Form',
  ExpandFormGroup = '[ClientLibrary] Expand Form Group',

  SelectForm = '[ClientLibrary] Select Form',
  SelectFormSuccess = '[ClientLibrary] Select Form Success',

  DeselectAllForms = '[ClientLibrary] Deselect All Forms',

  SelectLegacyForm = '[ClientLibrary] Select Legacy Form',
  SelectLegacyFormSuccess = '[ClientLibrary] Select Legacy Form Success',

  SelectFormTemplate = '[ClientLibrary] Select Form Template',
  SelectFormTemplateSuccess = '[ClientLibrary] Select Form Template Success',

  DeselectAllTemplates = '[ClientLibrary] Deselect All Form Templates',

  SearchForm = '[ClientLibrary] Search Content By Keyword',
  ResetSearchForm = '[ClientLibrary] Reset Search Content',

  DeleteForm = '[ClientLibrary] Delete Form',
  DeleteFormSuccess = '[ClientLibrary] Delete Form Success',

  RestoreForm = '[ClientLibrary] Restore Form',
  RestoreFormSuccess = '[ClientLibrary] Restore Form Success',

  RestoreForms = '[ClientLibrary] Restore Forms',
  RestoreFormsSuccess = '[ClientLibrary] Restore Forms Success',

  DeleteFormsBulk = '[ClientLibrary] Delete Forms',
  DeleteFormsBulkSuccess = '[ClientLibrary] Delete Forms Success',

  ChangeFormStatus = '[ClientLibrary] Change Form Status',
  ChangeFormStatusSuccess = '[ClientLibrary] Change Form Status Success',

  ChangeFormsDateOfPublicationBulk = '[ClientLibrary] Change Forms date of publication',

  CarryForwardForm = '[ClientLibrary] Carry Forward Form',
  CarryForwardFormSuccess = '[ClientLibrary] Carry Forward Form Success',

  ChangeFormsStatusBulk = '[ClientLibrary] Change Forms Status',
  ChangeFormsStatusBulkSuccess = '[ClientLibrary] Change Forms Status Success',

  FillSign = '[ClientLibrary] Fill And Sign Status',
  FillSignSuccess = '[ClientLibrary] Fill And Sign Status Success',
  FillSignFailure = '[ClientLibrary] Fill And Sign Status Failure',

  SetEditableForms = '[ClientLibrary] Set Editable Forms',
  SaveEditableForm = '[ClientLibrary] Save Editable Form',

  UploadPdf = '[ClientLibrary] Upload PDF',
  UploadPdfSuccess = '[ClientLibrary] Upload Pdf Success',

  SetPreviewForm = '[AccountLibrary] Set Preview Form',
  SetPreviewFormSuccess = '[AccountLibrary] Set Preview Form Success',

  SetPatientEmail = '[ClientLibrary] Set Patient Email',
  SetPatientEmailSuccess = '[ClientLibrary] Set Patient Email Success',

  SetCLFilters = '[ClientLibrary] Set CL Filters',
  SetCLFiltersSuccess = '[Client Library] Set CL Filters Success',

  SetCLOrderBy = '[ClientLibrary] Set OrderBy',
  SetCLOrderBySuccess = '[Client Library] Set OrderBy Success',

  SearchCL = '[ClientLibrary] Search Client Library',
  SearchCLSuccess = '[ClientLibrary] Search Client Library Success',

  ResetSearchCL = '[ClientLibrary] Reset Search Client Library',
  ResetSearchCLSuccess = '[ClientLibrary] Reset Search Client Library Success',

  ShareViaPortal = '[Client Library] Share Via Portal',
  UnshareViaPortal = '[Client Library] Unshare Via Portal',
  ShareUnshareViaPortalSuccess = '[Client Library] Share Unshare Via Portal Success',

  Error = '[ClientLibrary] Error',
}

export class LoadAccountLibrary implements Action {
  readonly type = ClientLibraryActionTypes.LoadAccountLibrary;
}

export class LoadAccountLibrarySuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadAccountLibrarySuccess;

  constructor(public payload: FormTemplate[]) {}
}

export class LoadClientLibraryFilterValues implements Action {
  readonly type = ClientLibraryActionTypes.LoadClientLibraryFilterValues;
  constructor(public payload: { patientId: number; field: ClientLibraryRemoteFilterField }) {}
}

export class LoadClientLibraryFilterValuesSuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadClientLibraryFilterValuesSuccess;

  constructor(
    public payload: {
      field: ClientLibraryRemoteFilterField;
      values: ClientLibrarySearchPropertiesModel[];
    },
  ) {}
}

export class LoadClientLibraryFilterValuesFailure implements Action {
  readonly type = ClientLibraryActionTypes.LoadClientLibraryFilterValuesFailure;

  constructor(public payload: { field: ClientLibraryRemoteFilterField }) {}
}

export class LoadClientLibrary implements Action {
  readonly type = ClientLibraryActionTypes.LoadClientLibrary;

  constructor(public payload: number) {}
}

export class LoadClientLibrarySuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadClientLibrarySuccess;

  constructor(public payload: { results: Form[]; totalCount: number }) {}
}

export class LoadNextClientLibraryPage implements Action {
  readonly type = ClientLibraryActionTypes.LoadNextClientLibraryPage;

  constructor(public payload: { patientId: number; limit: number; offset: number }) {}
}

export class LoadNextClientLibraryPageSuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadNextClientLibraryPageSuccess;

  constructor(public payload: { results: Form[]; totalCount: number }) {}
}

export class LoadArchivedLibrary implements Action {
  readonly type = ClientLibraryActionTypes.LoadArchivedLibrary;

  constructor(public payload: number) {}
}

export class LoadArchivedLibrarySuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadArchivedLibrarySuccess;

  constructor(public payload: Form[]) {}
}

export class LoadPatient implements Action {
  readonly type = ClientLibraryActionTypes.LoadPatient;

  constructor(public payload: number) {}
}

export class LoadPatientSuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadPatientSuccess;
  constructor(public payload: { patient: Client; appointments?: any[] }) {}
}

export class LoadFormWithTemplate implements Action {
  readonly type = ClientLibraryActionTypes.LoadFormWithTemplate;

  constructor(public payload: number) {}
}

export class LoadFormWithTemplateSuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadFormWithTemplateSuccess;

  constructor(public payload: any[]) {}
}

export class LoadLegacyForms implements Action {
  readonly type = ClientLibraryActionTypes.LoadLegacyForms;
  constructor(public payload: number) {}
}

export class LoadLegacyFormsSuccess implements Action {
  readonly type = ClientLibraryActionTypes.LoadLegacyFormsSuccess;

  constructor(public payload: PatientForm[]) {}
}

export class CreateForm implements Action {
  readonly type = ClientLibraryActionTypes.CreateForm;

  constructor(public payload: Form) {}
}

export class ExpandFormGroup implements Action {
  readonly type = ClientLibraryActionTypes.ExpandFormGroup;

  constructor(public payload: string) {}
}

export class SelectForm implements Action {
  readonly type = ClientLibraryActionTypes.SelectForm;

  constructor(public payload: Form) {}
}

export class SelectFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SelectFormSuccess;

  constructor(public payload: Form) {}
}

export class DeselectAllForms implements Action {
  readonly type = ClientLibraryActionTypes.DeselectAllForms;

  constructor(public payload?: any) {}
}

export class SelectFormTemplate implements Action {
  readonly type = ClientLibraryActionTypes.SelectFormTemplate;

  constructor(public payload: FormTemplate) {}
}

export class SelectFormTemplateSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SelectFormTemplateSuccess;

  constructor(public payload: FormTemplate) {}
}

export class DeselectAllTemplates implements Action {
  readonly type = ClientLibraryActionTypes.DeselectAllTemplates;

  constructor(public payload?: any) {}
}

export class SelectLegacyForm implements Action {
  readonly type = ClientLibraryActionTypes.SelectLegacyForm;

  constructor(public payload: PatientForm) {}
}

export class SelectLegacyFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SelectLegacyFormSuccess;

  constructor(public payload: PatientForm) {}
}

export class SearchForm implements Action {
  readonly type = ClientLibraryActionTypes.SearchForm;

  constructor(public payload: SearchModel) {}
}

export class ResetSearchForm implements Action {
  readonly type = ClientLibraryActionTypes.ResetSearchForm;
}

export class DeleteForm implements Action {
  readonly type = ClientLibraryActionTypes.DeleteForm;

  constructor(public payload: Form) {}
}

export class DeleteFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.DeleteFormSuccess;

  constructor(public payload: Form) {}
}

export class RestoreForm implements Action {
  readonly type = ClientLibraryActionTypes.RestoreForm;

  constructor(public payload: Form) {}
}

export class RestoreFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.RestoreFormSuccess;

  constructor(public payload: Form) {}
}

export class RestoreForms implements Action {
  readonly type = ClientLibraryActionTypes.RestoreForms;

  constructor(public payload: Form[]) {}
}

export class RestoreFormsSuccess implements Action {
  readonly type = ClientLibraryActionTypes.RestoreFormsSuccess;

  constructor(public payload: Form[]) {}
}

export class DeleteFormsBulk implements Action {
  readonly type = ClientLibraryActionTypes.DeleteFormsBulk;

  constructor(public payload: Form[]) {}
}

export class DeleteFormsBulkSuccess implements Action {
  readonly type = ClientLibraryActionTypes.DeleteFormsBulkSuccess;

  constructor(public payload: Form[]) {}
}

export class ChangeFormStatus implements Action {
  readonly type = ClientLibraryActionTypes.ChangeFormStatus;

  constructor(public payload: { formId: number; status: number }) {}
}

export class ChangeFormStatusSuccess implements Action {
  readonly type = ClientLibraryActionTypes.ChangeFormStatusSuccess;

  constructor(public payload: { formId: number; status: number }) {}
}

export class ChangeFormsDateOfPublicationBulk implements Action {
  readonly type = ClientLibraryActionTypes.ChangeFormsDateOfPublicationBulk;

  constructor(
    public payload: {
      patientId: number;
      data: { ids: number[]; publication_date: string };
    },
  ) {}
}

export class CarryForwardForm implements Action {
  readonly type = ClientLibraryActionTypes.CarryForwardForm;

  constructor(
    public payload: {
      formId: number;
      data: {
        publicationDate: string;
        appointmentId?: string;
        treatmentId?: string;
      };
    },
  ) {}
}

export class CarryForwardFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.CarryForwardFormSuccess;

  constructor(public payload: Form) {}
}

export class ChangeFormsStatusBulk implements Action {
  readonly type = ClientLibraryActionTypes.ChangeFormsStatusBulk;

  constructor(
    public payload: {
      ids: number[];
      status: number;
      shared_with_patient?: boolean;
    },
  ) {}
}

export class ChangeFormsStatusBulkSuccess implements Action {
  readonly type = ClientLibraryActionTypes.ChangeFormsStatusBulkSuccess;

  constructor(
    public payload: {
      ids: number[];
      status: number;
      forms?: Form[];
    },
  ) {}
}

export class SetEditableForms implements Action {
  readonly type = ClientLibraryActionTypes.SetEditableForms;

  constructor(public payload: Form[]) {}
}

export class SaveEditableForm implements Action {
  readonly type = ClientLibraryActionTypes.SaveEditableForm;

  constructor(public payload: { id: number; form_data: string }) {}
}

export class FillSign implements Action {
  readonly type = ClientLibraryActionTypes.FillSign;

  constructor(
    public payload: { id: number; data: any },
    public formsStatusBulk: any = null,
  ) {}
}

export class FillSignSuccess implements Action {
  readonly type = ClientLibraryActionTypes.FillSignSuccess;

  constructor(public payload: { id: number; data: any }) {}
}

export class FillSignFailure implements Action {
  readonly type = ClientLibraryActionTypes.FillSignFailure;

  constructor(
    public readonly formId: number,
    public readonly error: unknown,
  ) {}
}

export class UploadPdf implements Action {
  readonly type = ClientLibraryActionTypes.UploadPdf;

  constructor(
    public payload: {
      template: FormTemplate;
      status: number;
      patientId: number;
      date: any;
    },
  ) {}
}

export class UploadPdfSuccess implements Action {
  readonly type = ClientLibraryActionTypes.UploadPdfSuccess;

  constructor(public payload: any) {}
}

export class SetPreviewForm implements Action {
  readonly type = ClientLibraryActionTypes.SetPreviewForm;

  constructor(public payload: Form) {}
}

export class SetPreviewFormSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SetPreviewFormSuccess;

  constructor(public payload: Form) {}
}

export class SetPatientEmail implements Action {
  readonly type = ClientLibraryActionTypes.SetPatientEmail;

  constructor(public payload: { patient: number; email: string }) {}
}

export class SetPatientEmailSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SetPatientEmailSuccess;
}

export class SetCLFilters implements Action {
  readonly type = ClientLibraryActionTypes.SetCLFilters;

  constructor(public payload: ClientLibrarySearchFilters) {}
}

export class SetCLFiltersSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SetCLFiltersSuccess;
}

export class SetCLOrderBy implements Action {
  readonly type = ClientLibraryActionTypes.SetCLOrderBy;
  constructor(public payload: SortClientLibrary) {}
}

export class SetCLOrderBySuccess implements Action {
  readonly type = ClientLibraryActionTypes.SetCLOrderBySuccess;
}

export class SearchCL implements Action {
  readonly type = ClientLibraryActionTypes.SearchCL;
  constructor(public payload: SearchModel) {}
}

export class SearchCLSuccess implements Action {
  readonly type = ClientLibraryActionTypes.SearchCLSuccess;
}

export class ResetSearchCL implements Action {
  readonly type = ClientLibraryActionTypes.ResetSearchCL;
}

export class ResetSearchCLSuccess implements Action {
  readonly type = ClientLibraryActionTypes.ResetSearchCLSuccess;
}

export class ShareViaPortal implements Action {
  readonly type = ClientLibraryActionTypes.ShareViaPortal;
  constructor(
    public payload: {
      ids: number[];
      shared_with_patient: boolean;
      fill_n_sign_notifications?: string[];
      editedData?: { id: number; data: object };
    },
  ) {}
}

export class ShareUnshareViaPortalSuccess implements Action {
  readonly type = ClientLibraryActionTypes.ShareUnshareViaPortalSuccess;
  constructor(public payload: Form[]) {}
}

export class UnshareViaPortal implements Action {
  readonly type = ClientLibraryActionTypes.UnshareViaPortal;
  constructor(public payload: any) {}
}

export class Error implements Action {
  readonly type = ClientLibraryActionTypes.Error;

  constructor(public payload: string) {}
}

export type ClientLibraryActions =
  | LoadAccountLibrary
  | LoadAccountLibrarySuccess
  | LoadClientLibraryFilterValues
  | LoadClientLibraryFilterValuesSuccess
  | LoadClientLibraryFilterValuesFailure
  | LoadClientLibrary
  | LoadClientLibrarySuccess
  | LoadNextClientLibraryPage
  | LoadNextClientLibraryPageSuccess
  | LoadArchivedLibrary
  | LoadArchivedLibrarySuccess
  | LoadPatient
  | LoadPatientSuccess
  | LoadFormWithTemplate
  | LoadFormWithTemplateSuccess
  | LoadLegacyForms
  | LoadLegacyFormsSuccess
  | CreateForm
  | ExpandFormGroup
  | SelectForm
  | SelectFormSuccess
  | SelectLegacyForm
  | SelectLegacyFormSuccess
  | DeselectAllForms
  | SelectFormTemplate
  | SelectFormTemplateSuccess
  | DeselectAllTemplates
  | SearchForm
  | ResetSearchForm
  | DeleteForm
  | DeleteFormSuccess
  | RestoreForm
  | RestoreFormSuccess
  | RestoreForms
  | RestoreFormsSuccess
  | DeleteFormsBulk
  | DeleteFormsBulkSuccess
  | ChangeFormStatus
  | ChangeFormStatusSuccess
  | ChangeFormsDateOfPublicationBulk
  | CarryForwardForm
  | CarryForwardFormSuccess
  | ChangeFormsStatusBulk
  | ChangeFormsStatusBulkSuccess
  | SetEditableForms
  | SaveEditableForm
  | FillSign
  | FillSignSuccess
  | FillSignFailure
  | SetPreviewForm
  | SetPreviewFormSuccess
  | SetPatientEmail
  | SetPatientEmailSuccess
  | UploadPdf
  | UploadPdfSuccess
  | UnshareViaPortal
  | ShareViaPortal
  | ShareUnshareViaPortalSuccess
  | SetCLFilters
  | SetCLFiltersSuccess
  | SetCLOrderBy
  | SetCLOrderBySuccess
  | SearchCLSuccess
  | SearchCL
  | ResetSearchCL
  | ResetSearchCLSuccess
  | Error;
